import {
  CheckCircleIcon,
  ExclamationCircleIcon,
} from '@heroicons/react/24/outline';
import { useTranslations } from 'next-intl';

interface PasswordCriteriaProps {
  password: string;
}

export default function PasswordCriteria({ password }: PasswordCriteriaProps) {
  const t = useTranslations('Components.Form.PasswordCriteria');

  const isLengthValid = password && password.length >= 8;
  const hasUppercase = !password ? false : /[A-Z]/.test(password);
  const hasLowercase = !password ? false : /[a-z]/.test(password);
  const hasNumber = !password ? false : /[0-9]/.test(password);
  const hasSpecialChar = !password ? false : /[!@#$%^&*(),.?":{}|<>]/.test(password);

  const criteria = [
    { valid: isLengthValid, text: t('minLength') },
    { valid: hasUppercase, text: t('uppercase') },
    { valid: hasLowercase, text: t('lowercase') },
    { valid: hasNumber, text: t('number') },
    { valid: hasSpecialChar, text: t('specialCharacter') },
  ];

  return (
    <div className='mt-4 rounded-lg border border-[#86D3E4] bg-[#04323C] p-4'>
      <div className='mb-2 flex items-center font-bold text-[#86D3E4]'>
        <ExclamationCircleIcon className='h-5 w-5' />
        <span className='ml-2'>{t('title')}</span>
      </div>
      <ul className='space-y-2'>
        {criteria.map((item, index) => (
          <li key={index} className='flex items-center'>
            {item.valid ? (
              <CheckCircleIcon className='h-5 w-5 text-[#86D3E4]' />
            ) : (
              <span className='inline-block h-5 w-5'></span>
            )}
            <span
              className={`ml-2 ${
                item.valid ? 'text-[#86D3E4]' : 'text-[#0C95B5]'
              }`}
            >
              {item.text}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
